import React from "react";
import PropTypes from "prop-types";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function BhavaDataTable({ bhavaData }) {
    return (
        <div>
            <div style={sectionTitleStyle}>
                භාවස්ථුට
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>භාවය</th>
                        <th style={thStyleCompact}>රාශිය</th>
                        <th style={thStyleCompact}>ස්ථුටය</th>
                        <th style={thStyleCompact}>නැකත</th>
                        <th style={thStyleCompact}>උප ග්‍රහ</th>
                        <th style={thStyleCompact}>උප උප ග්‍රහ</th>
                        <th style={thStyleCompact}>උප උප උප ග්‍රහ</th>
                        <th style={thStyleCompact}>භාවගත ග්‍රහයෝ</th>
                    </tr>
                </thead>
                <tbody>
                    {bhavaData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}>{row.bhavaIndex}</td>
                            <td style={tdStyleCompact}>{row.rasi}</td>
                            <td style={tdStyleCompact}>{row.place}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.upaUpaGraha}</td>
                            <td style={tdStyleCompact}>{row.upaUpaUpaGraha}</td>
                            <td style={tdStyleCompact}>{row.gahasInBhava}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

BhavaDataTable.propTypes = {
    bhavaData: PropTypes.array.isRequired,
};
